export default __webpack_public_path__ + "static/media/Screenshot_2.81eb63b1.png";